import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatDatepicker, MatDatepickerInputEvent } from '@angular/material/datepicker';
import { MatDialog } from '@angular/material/dialog';
import { MatSelect } from '@angular/material/select';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { PaymentHistoryRequest } from 'src/app/core/models/request/payment-history.request';
import { IdentityService } from 'src/app/core/services/identity.service';
import { NativeBridgeService } from 'src/app/core/services/native-bridge.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import { PaymentIconsService } from 'src/app/core/services/payment-icons.service';
import { PaymentsFilterService } from 'src/app/core/services/payments-filter.service';
import { PaymentsService } from 'src/app/core/services/payments.service';
import { StorageService } from 'src/app/core/services/storage.service';
import { UserService } from 'src/app/core/services/user.services';
import { DetailPayComponent } from 'src/app/pages/detail-pay/detail-pay.component';
import { DetailPaymentService } from 'src/app/pages/detail-pay/services/detail.payment.service';
import { dateFormatNotHour } from 'src/app/shared/functions/date.functions';
import { ActionOptions } from 'src/app/shared/interfaces/actionOption';
import { AppIcon } from 'src/app/shared/interfaces/app-icon';
import { IOptionsNgSelect } from 'src/app/shared/interfaces/ioptionsNgSelect';

@Component({
  selector: 'app-movements-list',
  templateUrl: './movements-list.component.html',
  styleUrls: ['./movements-list.component.scss']
})
export class MovementsListComponent implements OnInit {
  @ViewChild('fechaDesde') fechaDesde: ElementRef;
  @ViewChild('fechaHasta') fechaHasta: ElementRef;
  @ViewChild('estadoMatSelect') selectEstado: MatSelect;
  @ViewChild('medioPagoMatSelect') medioPagoSelect: MatSelect;
  @ViewChild('branchMatSelect') selectBranch: MatSelect;
  @ViewChild('cashierMatSelect') selectCashier: MatSelect;
  @ViewChild('picker') pickerTo: MatDatepicker<1>;
  @ViewChild('picker1') pickerFrom: MatDatepicker<2>;

  downloadLoading = false;

  constructor(
    public dialog: MatDialog,
    private filterService: PaymentsFilterService,
    private paymentsService: PaymentsService,
    private storage: StorageService,
    private translateService: TranslateService,
    private paymentIconsService: PaymentIconsService,
    private data: DetailPaymentService,
    private notificationService: NotificationService,
    private identity: IdentityService,
    private userService: UserService,
    private nativeBridgeService: NativeBridgeService
  ) {
    this.minDate = new Date();
  }

  minDate: Date;
  medioActual: any = [];
  showOptions: boolean = false;
  search = new UntypedFormControl('');
  searchBranch = new UntypedFormControl('');
  searchCashier = new UntypedFormControl('');
  loading: boolean;
  totalSize: any = 0;
  filter: string = '';

  dateTo: Date;
  dateFrom: Date;
  estadoActual = [];
  sucursalActual = [];
  cajaActual = [];
  filterMovs: any;
  paymentMethodCollection: IOptionsNgSelect[];
  branchOfficesCollection: IOptionsNgSelect[];

  estadoPagoSelect: string[];
  branchOfficeSelect: number[];
  cashierSelect: number[];
  paymentMethodSelect: number[];
  movimientosList: any;
  noMovements: boolean = false;
  pageActual: number = 1;

  branchCollection: any[];
  cashierCollection: IOptionsNgSelect[];
  branchFilter: IOptionsNgSelect[];
  cashierFilter: IOptionsNgSelect[];
  commerceUser: boolean = true;
  userResponsible: boolean = true;
  disabledPicker: boolean = true;
  appEnvironment: string;

  estadoSelect = [
    { estado: 'Todos' },
    { estado: 'Confirmado', value: 'Confirmado' },
    { estado: 'Acreditado', value: 'Acreditado' },
    { estado: 'Aprobado', value: 'Aprobado' },
    { estado: 'Pendiente', value: 'Pendiente' },
    { estado: 'Anulado', value: 'Anulado' },
    { estado: 'Rechazado', value: 'Rechazado' }
  ];

  medioPago = [
    { medioPago: 'Todos' },
    { medioPago: 'American Express', value: 'Amex' },
    { medioPago: 'ANK', value: 'app.ank' },
    { medioPago: 'BNA+', value: 'ar.com.bna' },
    { medioPago: 'Cabal', value: 'Cabal' },
    { medioPago: 'Caja plus', value: 'Adelantos Caja Plus' },
    { medioPago: 'Claro', value: 'com.claro' },
    { medioPago: 'Columbia', value: 'com.columbia' },
    { medioPago: 'Cuenta DNI', value: 'ar.com.cuentadni' },
    { medioPago: 'Maestro', value: 'Maestro' },
    { medioPago: 'MasterCard', value: 'Mastercard' },
    { medioPago: 'Mercado Pago', value: 'com.mercadolibre' },
    { medioPago: 'MODO', value: 'ar.com.modo' },
    { medioPago: 'Moni', value: 'ar.com.moni' },
    { medioPago: 'Rapipago', value: 'Rapipago' },
    { medioPago: 'Reba', value: 'reba' },
    { medioPago: 'Santander', value: 'ar.com.santander' },
    { medioPago: 'Visa', value: 'Visa' },
    { medioPago: 'Yacaré', value: 'Cuenta Yacaré' },
    { medioPago: 'Miiii', value: 'app.miiii' },
    { medioPago: 'E pagos', value: 'ar.com.epagos' },
    { medioPago: 'Ualá', value: 'ar.com.uala' },
    { medioPago: 'Re simple', value: 'com.resimple' },
    { medioPago: 'Vale Pei', value: 'ar.com.valepei' },
    { medioPago: 'Plus pagos', value: 'com.pluspagos' },
    { medioPago: 'Tap', value: 'com.auntap' },
    { medioPago: 'Personal Pay', value: 'ar.com.personalpay' }
  ];

  fechas = [
    { periodo: 'Todos' },
    { periodo: 'Hoy', value: 'hoy' },
    { periodo: 'Ayer', value: 'ayer' },
    { periodo: 'Ultima semana', value: 'semana' },
    { periodo: 'Ultimo mes', value: 'mes' },
    { periodo: 'Ultimos dos meses', value: 'dos-meses' }
  ];

  estadoDelPago: Array<IOptionsNgSelect>;

  async ngOnInit() {
    this.estadoDelPago = [
      { value: 1, display: this.translate('constants.payment_status.d'), type: 'D' },
      { value: 2, display: this.translate('constants.payment_status.a'), type: 'A' },
      { value: 3, display: this.translate('constants.payment_status.p'), type: 'P' },
      { value: 4, display: this.translate('constants.payment_status.c'), type: 'C' },
      { value: 5, display: this.translate('constants.payment_status.r'), type: 'R' },
      { value: 6, display: this.translate('constants.payment_status.n'), type: 'N' },
      { value: 7, display: this.translate('constants.payment_status.u'), type: 'U' },
      { value: 8, display: this.translate('constants.payment_status.e'), type: 'E' }
    ] as IOptionsNgSelect[];
    this.appEnvironment = this.nativeBridgeService.getEnvironment();
    this.loading = true;
    this.filterMovs = [];
    this.commerceUser = this.identity.isCommerce();
    this.userResponsible = this.identity.isRolResponsible();

    this.commerceUser || this.userResponsible ? this.LoadCommerce() : await this.loadPaymentMethodCollection();

    await this.getDataGrid();
    this.search.valueChanges.pipe(debounceTime(50)).subscribe((value) => {
      this.filter = value;
    });

    this.searchBranch.valueChanges.pipe(debounceTime(150)).subscribe((value) => {
      value
        ? (this.branchFilter = this.branchOfficesCollection.filter((branch) =>
            branch.display.toUpperCase().includes(value.toUpperCase())
          ))
        : (this.branchFilter = this.branchOfficesCollection);
    });

    this.searchCashier.valueChanges.pipe(debounceTime(150)).subscribe((value) => {
      value
        ? (this.cashierFilter = this.cashierCollection.filter((cashier) =>
            cashier.display.toUpperCase().includes(value.toUpperCase())
          ))
        : (this.cashierFilter = this.cashierCollection);
    });

    this.loading = false;
  }

  private loadChashier() {
    this.userService.getCashiers().then((cashier) => {
      this.cashierCollection = Array<IOptionsNgSelect>();
      cashier.forEach((ob) => {
        if (this.branchOfficeSelect) {
          if (this.branchOfficeSelect.includes(ob.branchOffice.id)) {
            const opt = { value: ob.id, display: ob.name, type: ob.name };
            this.cashierCollection.push(opt as IOptionsNgSelect);
          }
        } else {
          const opt = { value: ob.id, display: ob.name, type: ob.name };
          this.cashierCollection.push(opt as IOptionsNgSelect);
        }
      });
      this.cashierFilter = this.cashierCollection;
    });
  }

  private loadbranchOffices() {
    this.userService.getBranchOfficesCollection().then((officeBranches) => {
      this.branchOfficesCollection = Array<IOptionsNgSelect>();
      officeBranches.forEach((ob) => {
        const opt = { value: ob.id, display: ob.name, type: ob.name };
        this.branchOfficesCollection.push(opt as IOptionsNgSelect);
      });
      this.branchFilter = this.branchOfficesCollection;
    });
  }

  private loadPaymentMethodCollection() {
    this.userService.getPaymentMethodCollection().then((response) => {
      this.paymentMethodCollection = Array<IOptionsNgSelect>();
      response.forEach((ob) => {
        const opt = { value: ob.id, display: ob.nombre, type: ob.nombre };
        this.paymentMethodCollection.push(opt as IOptionsNgSelect);
      });
    });
  }

  async LoadCommerce() {
    await this.loadPaymentMethodCollection();
    await this.loadChashier();
    await this.loadbranchOffices();
  }

  maskPrice(price: string) {
    if (price.startsWith('-')) {
      let importe = price.slice(1);
      return `-$${importe}`;
    } else {
      return `$${price}`;
    }
  }

  maskCuit(cuit: string) {
    let first = cuit.substring(0, 2);
    let dni = cuit.substring(2, 10);
    let end = cuit.substring(10, 11);
    return `${first}-${dni}-${end}`;
  }

  isPSP(billetera): boolean {
    if (billetera !== null) {
      return billetera.length == 4 ? true : false;
    }
    return false;
  }

  getIconWallet(billetera, cvu, mp) {
    return this.isPSP(billetera) || billetera == null
      ? this.paymentIconsService.getIcon(mp, cvu.slice(3, 7))
      : this.paymentIconsService.getIcon(mp, billetera);
  }

  getIcon(mov): AppIcon {
    return mov.medioPagoView == 'Transferencia 3.0'
      ? this.getIconWallet(mov.billetera, mov.cvuContraparte, mov.medioPagoView)
      : this.paymentIconsService.getIcon(mov.medioPagoView, mov.billetera);
  }

  setClassEstado(estado: string) {
    if (estado == 'Confirmado') return 'confirmado';
    else if (estado == 'Acreditado') return 'confirmado';
    else if (estado == 'Aprobado') return 'confirmado';
    else if (estado == 'Pendiente') return 'pendiente';
    else if (estado == 'Anulado') return 'anulado';
    else return 'error';
  }

  stateButtonClean() {
    if (this.search.value !== '') {
      return false;
    } else if (this.dateTo) {
      return false;
    } else if (this.dateFrom) {
      return false;
    } else if (this.estadoActual) {
      return false;
    } else if (this.medioActual) {
      return false;
    } else if (this.cajaActual) {
      return false;
    } else if (this.sucursalActual) {
      return false;
    } else {
      return true;
    }
  }

  async nextPage() {
    await this.getDataGrid(this.pageActual);
  }

  async getDataGrid(page?: number) {
    this.loading = true;
    const request = page ? this.createRequest(false, page) : this.createRequest();
    await this.cargarMovimientos(request);
    this.loading = false;
  }

  async filtroGeneralV2() {
    this.loading = true;
    this.totalSize = 0;
    let request = this.createRequest(false, 0);
    await this.cargarMovimientos(request);
    this.loading = false;
  }

  async cargarMovimientos(request) {
    this.filterMovs = [];
    const movimientos = await this.paymentsService.getPaymentHistory(request);
    this.totalSize = movimientos.size;
    this.movimientosList = movimientos.list;
    this.filterMovs = this.movimientosList;
  }

  async cleanFiltersV2() {
    //search
    if (this.search.value !== '') {
      this.search.setValue('');
      this.filter = '';
    }

    //datepicker dateTo
    this.dateTo = null;
    this.fechaDesde.nativeElement.value = '';
    this.pickerTo.select = null;

    //datepicker dateFrom
    this.dateFrom = null;
    this.fechaHasta.nativeElement.value = '';
    this.pickerFrom.select = null;

    this.disabledPicker = true;

    //selects (medio de pago, sucursal y cajas)
    this.medioActual = this.medioPagoSelect.value = [];
    this.estadoActual = this.selectEstado.value = [];

    if (this.selectCashier) {
      this.cajaActual = this.selectCashier.value = [];
    }
    if (this.selectBranch) {
      this.sucursalActual = this.selectBranch.value = [];
    }

    this.pageActual = 0;
    this.totalSize = 0;

    await this.getDataGrid(0);
  }

  selectionChangeMethod() {
    this.medioActual = this.medioPagoSelect.value;
  }

  selectionChangeEstado() {
    this.estadoActual = this.selectEstado.value;
  }

  selectionChangeCashier() {
    this.cajaActual = this.selectCashier.value;
  }

  selectionChangeBranch() {
    this.sucursalActual = this.selectBranch.value;
  }

  fechaDesdePicker(event: MatDatepickerInputEvent<Date>, type?: string): void {
    this.dateFrom = new Date(event.value);
    this.minDate = this.dateFrom;
    this.disabledPicker = false;
  }

  fechaHastaPicker(event: MatDatepickerInputEvent<Date>, type?: string): void {
    this.dateTo = new Date(event.value);
  }

  private createRequest(allSize?: boolean, page?: number): PaymentHistoryRequest {
    let request = new PaymentHistoryRequest();
    let pagina = page;
    if (allSize != undefined && allSize) {
      request.elements = this.totalSize;
      request.page = 0;
    } else {
      request.elements = 10;
      request.page = pagina ? pagina - 1 : 0;
    }
    request.fechaDesde = dateFormatNotHour(this.dateFrom);
    request.estadosPago = new Array<string>();
    if (this.dateFrom && this.dateTo) {
      request.fechaHasta = dateFormatNotHour(this.dateTo);
      if (this.dateFrom > this.dateTo) {
        this.notificationService.mgsView({
          error: null,
          messenger: this.translate('pages.list_pay.messages.date_span_error'),
          title: this.translate('pages.list_pay.labels.movements'),
          type: 3,
          configNotification: null
        });
        return;
      }
    }

    if (this.filter !== '' && this.filter.length > 0) {
      request.filter = this.filter.trim();
    }

    if (this.estadoActual && this.estadoActual.length > 0) {
      this.estadoActual.forEach((element) => {
        request.estadosPago.push(this.estadoDelPago[+element - 1].type);
      });
    } else {
      this.estadoDelPago.forEach((element) => {
        request.estadosPago.push(element.type);
      });
    }

    if (this.sucursalActual && this.sucursalActual.length > 0) {
      request.idsSucursales = new Array<number>();
      this.sucursalActual.forEach((element) => {
        request.idsSucursales.push(element);
      });
    }

    if (this.cajaActual && this.cajaActual.length > 0) {
      request.idsCashier = new Array<number>();
      this.cajaActual.forEach((element) => {
        request.idsCashier.push(element);
      });
    }

    if (this.medioActual && this.medioActual.length > 0) {
      request.idsPaymentMethods = new Array<number>();
      this.medioActual.forEach((element) => {
        request.idsPaymentMethods.push(element);
      });
    }

    return request;
  }

  clickInAction(element: any, action: ActionOptions) {
    switch (action.name) {
      case 'pageview': {
        this.data.storage = element;
        const diagRef = this.dialog.open(DetailPayComponent, { minWidth: '350px' });
        diagRef.afterClosed().subscribe((x) => (x ? (x.refresh ? this.getDataGrid() : null) : null));
        break;
      }

      case 'save_alt': {
        this.paymentsService
          .downloadTicket(element.id)
          .then(() => {
            this.downloadLoading = false;
          })
          .catch(() => {
            this.downloadLoading = false;
          });
        break;
      }
    }
  }

  expandSearch: boolean = false;
  bounceSearch: boolean;
  inputFindEventHandler: Subject<string>;

  set inputFindModel(value: string) {
    this.bounceSearch = true;
    this.inputFindEventHandler.next(value);
  }

  onKey(event) {
    console.log(event);
  }

  expand() {
    this.expandSearch = true;
  }

  async excelExport() {
    if (!this.dateFrom && !this.dateTo) {
      this.notificationService.mgsView({
        error: null,
        messenger: this.translate('pages.list_pay.messages.date_range'),
        title: this.translate('pages.list_pay.labels.movements'),
        type: 3,
        configNotification: null
      });
    } else {
      await this.paymentsService.downloadExcel(this.createRequest(true));
      this.dateFrom = null;
      this.dateTo = null;
    }
  }

  translate(key: string): string {
    return this.translateService.instant(key);
  }
}
